// src/pages/ChatWithAI/components/dialogs/AnexarCasoDialog.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './AnexarDialog.css';

const AnexarCasoDialog = ({ onClose, onAnexar }) => {
  const [casos, setCasos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState('');
  const [selectedCasoId, setSelectedCasoId] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    fetchCasos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, page]);

  const fetchCasos = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get('/api/attachments/casos/list', {
        params: {
          search,
          page,
          limit: 10
        }
      });

      if (response.data.success) {
        if (page === 1) {
          setCasos(response.data.data);
        } else {
          setCasos(prev => [...prev, ...response.data.data]);
        }
        setHasMore(response.data.pagination.hasMore);
      }
    } catch (err) {
      console.error('❌ Erro ao buscar casos:', err);
      setError(err.response?.data?.message || 'Erro ao carregar casos');
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPage(1);
    setCasos([]);
  };

  const handleLoadMore = () => {
    if (!loading && hasMore) {
      setPage(prev => prev + 1);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedCasoId) {
      setError('Selecione um caso');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      await onAnexar(selectedCasoId);
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('pt-PT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const truncateText = (text, maxLength = 50) => {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  return (
    <div className="anexar-dialog-overlay" onClick={onClose}>
      <div className="anexar-dialog anexar-dialog-large" onClick={(e) => e.stopPropagation()}>
        <div className="anexar-dialog-header">
          <h3>📁 Anexar Caso</h3>
          <button onClick={onClose} className="anexar-dialog-close">✕</button>
        </div>

        <form onSubmit={handleSubmit} className="anexar-dialog-content">
          <div className="form-group">
            <label>Pesquisar casos</label>
            <input
              type="text"
              placeholder="Nome ou descrição do caso..."
              value={search}
              onChange={handleSearchChange}
              className="search-input"
            />
          </div>

          <div className="documentos-list-container">
            {loading && page === 1 && (
              <div className="loading-state">
                <div className="spinner"></div>
                <p>Carregando casos...</p>
              </div>
            )}

            {!loading && casos.length === 0 && (
              <div className="empty-state">
                <p>Nenhum caso encontrado</p>
              </div>
            )}

            {casos.length > 0 && (
              <div className="documentos-list">
                {casos.map((caso) => (
                  <label
                    key={caso.id}
                    className={`documento-item ${selectedCasoId === caso.id ? 'selected' : ''}`}
                  >
                    <input
                      type="radio"
                      name="caso"
                      value={caso.id}
                      checked={selectedCasoId === caso.id}
                      onChange={() => setSelectedCasoId(caso.id)}
                    />
                    <div className="documento-info">
                      <div className="documento-header">
                        <span className="documento-icon">📁</span>
                        <span className="caso-id">#{caso.id}</span>
                      </div>
                      <div className="documento-nome caso-name">
                        {truncateText(caso.name, 50)}
                      </div>
                      {caso.description && (
                        <div className="caso-description">
                          {truncateText(caso.description, 80)}
                        </div>
                      )}
                      <div className="documento-meta">
                        <span className="documento-date">
                          {formatDate(caso.created_at)}
                        </span>
                      </div>
                    </div>
                  </label>
                ))}

                {hasMore && !loading && (
                  <button
                    type="button"
                    onClick={handleLoadMore}
                    className="load-more-btn"
                  >
                    Carregar mais
                  </button>
                )}

                {loading && page > 1 && (
                  <div className="loading-more">
                    Carregando...
                  </div>
                )}
              </div>
            )}
          </div>

          {error && (
            <div className="anexar-error">
              ⚠️ {error}
            </div>
          )}

          <div className="anexar-dialog-actions">
            <button
              type="button"
              onClick={onClose}
              className="anexar-btn-cancel"
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="anexar-btn-submit"
              disabled={!selectedCasoId || loading}
            >
              {loading ? 'Anexando...' : 'Anexar Caso'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AnexarCasoDialog;// src/pages/ChatWithAI/components/dialogs/AnexarCasoDialog.js
